import { IHousePlanHit } from '@/lib/search/types';
import { IFilterConfig, ISortOption } from './or-filtered-grid.types';
import { AtDropdown } from '@/components/atoms';

export const mockHousePlanData: IHousePlanHit[] = [
  {
    BaseElevationPrice: 12345,
    Depth: 54,
    ExteriorStyle: {
      Id: 10,
      Name: 'Modern Hill Country',
      ExteriorStyleCategoryId: 5,
    },
    Id: 609,
    Image:
      'https://static.schumacherhomes.com/public/assets/homes/Columbus-Charleston_2023.jpeg',
    IsBaseElevation: false,
    FloorPlans: [
      {
        BasePrice: 500,
        ElevationId: 2,
        HasModelHome: true,
        Id: 1,
        IsPopular: true,
        IsPreferred: false,
        PlanId: 200,
        PopularRank: 1,
        StudioId: 1,
        FloorPlanImages: [
          {
            FileName:
              'https://static.schumacherhomes.com/public/assets/homes/Charleston-Traditional-Farmhouse.jpg',
            Type: 'Main story',
            TypeId: 1,
          },
        ],
      },
    ],
    IsPopular: false,
    IsPreferred: true,
    Name: 'Charleston Modern Hill Country',
    PopularRank: 0,
    SquareFeet: 2400,
    Width: 64,
    HasFloorPlans: false,
    indexName: '',
    Plan: {
      Bathrooms: 2,
      Bedrooms: 4,
      Collection: null,
      FlexRoom: true,
      FlexRoomIsBedroom: true,
      HasGarage: true,
      Id: 31,
      IsMultiGen: true,
      Name: 'Charleston',
      SimilarPlans: [
        { SimilarPlanId: 17 },
        { SimilarPlanId: 53 },
        { SimilarPlanId: 85 },
      ],
      Stories: [
        { Id: 1, Name: '1 Story' },
        { Id: 7, Name: "Dual Owner's Retreat" },
      ],
    },
    objectID: '31_609',

    Elevations: [],
  },
  {
    BaseElevationPrice: 12345,
    Depth: 54,
    ExteriorStyle: {
      Id: 15,
      ExteriorStyleCategoryId: 4,
      Name: 'New American Tradition',
    },
    Id: 605,
    FloorPlans: [
      {
        BasePrice: 500,
        ElevationId: 2,
        HasModelHome: true,
        Id: 1,
        IsPopular: true,
        IsPreferred: true,
        PlanId: 200,
        PopularRank: 1,

        StudioId: 1,
        FloorPlanImages: [
          {
            FileName:
              'https://static.schumacherhomes.com/public/assets/homes/Charleston-Traditional-Farmhouse.jpg',
            Type: 'Main story',
            TypeId: 1,
          },
        ],
      },
    ],
    Image:
      'https://static.schumacherhomes.com/public/assets/homes/cincinnati-charleston-ext.jpg',
    IsBaseElevation: false,
    IsPopular: false,
    IsPreferred: false,
    Name: 'Charleston New American Tradition',
    PopularRank: 0,
    SquareFeet: 2400,
    Width: 64,
    HasFloorPlans: false,

    indexName: '',

    Plan: {
      Bathrooms: 2,
      Bedrooms: 2,
      Collection: null,
      FlexRoom: true,
      FlexRoomIsBedroom: true,
      HasGarage: true,
      Id: 31,
      IsMultiGen: true,
      Name: 'Aberdeen',
      SimilarPlans: [
        { SimilarPlanId: 17 },
        { SimilarPlanId: 53 },
        { SimilarPlanId: 85 },
      ],
      Stories: [
        { Id: 1, Name: '1 Story' },
        { Id: 7, Name: "Dual Owner's Retreat" },
      ],
    },
    objectID: '31_605',

    Elevations: [],
  },
  {
    BaseElevationPrice: 12345,
    Depth: 54,

    indexName: '',

    FloorPlans: [
      {
        BasePrice: 500,
        ElevationId: 2,
        HasModelHome: true,
        Id: 1,
        IsPopular: true,
        IsPreferred: true,
        PlanId: 200,
        PopularRank: 1,

        StudioId: 1,
        FloorPlanImages: [
          {
            FileName:
              'https://static.schumacherhomes.com/public/assets/homes/Charleston-Traditional-Farmhouse.jpg',
            Type: 'Main story',
            TypeId: 1,
          },
        ],
      },
    ],
    ExteriorStyle: { Id: 13, ExteriorStyleCategoryId: 1, Name: 'Modern' },
    Id: 532,
    Image:
      'https://static.schumacherhomes.com/public/assets/homes/rCharleston-Modern.jpg',
    IsBaseElevation: false,
    IsPopular: false,
    IsPreferred: false,
    Name: 'Charleston Modern',
    PopularRank: 0,
    SquareFeet: 2400,
    Width: 64,
    HasFloorPlans: false,
    Plan: {
      Bathrooms: 2,
      Bedrooms: 5,
      Collection: null,
      FlexRoom: true,
      FlexRoomIsBedroom: true,
      HasGarage: true,
      Id: 31,
      IsMultiGen: true,
      Name: 'Davidson',
      SimilarPlans: [
        { SimilarPlanId: 17 },
        { SimilarPlanId: 53 },
        { SimilarPlanId: 85 },
      ],
      Stories: [
        { Id: 1, Name: '1 Story' },
        { Id: 7, Name: "Dual Owner's Retreat" },
      ],
    },
    objectID: '31_532',

    Elevations: [],
  },
  {
    BaseElevationPrice: 12345,
    Depth: 54,
    ExteriorStyle: {
      Id: 3,
      ExteriorStyleCategoryId: 3,
      Name: 'French Country',
    },
    Id: 514,
    Image:
      'https://static.schumacherhomes.com/public/assets/homes/rCharleston-French-Country.jpg',
    IsBaseElevation: false,
    IsPopular: false,
    FloorPlans: [
      {
        BasePrice: 500,
        ElevationId: 2,
        HasModelHome: true,
        Id: 1,
        IsPopular: true,
        IsPreferred: true,
        PlanId: 200,
        PopularRank: 1,

        StudioId: 1,
        FloorPlanImages: [
          {
            FileName:
              'https://static.schumacherhomes.com/public/assets/homes/Charleston-Traditional-Farmhouse.jpg',
            Type: 'Main story',
            TypeId: 1,
          },
        ],
      },
    ],
    IsPreferred: false,
    Name: 'Charleston French Country',
    PopularRank: 0,
    SquareFeet: 2400,
    Width: 64,

    indexName: '',

    HasFloorPlans: false,
    Plan: {
      Bathrooms: 2,
      Bedrooms: 6,
      Collection: null,
      FlexRoom: true,
      FlexRoomIsBedroom: true,
      HasGarage: true,
      Id: 31,
      IsMultiGen: true,
      Name: 'Pikes Peak',
      SimilarPlans: [
        { SimilarPlanId: 17 },
        { SimilarPlanId: 53 },
        { SimilarPlanId: 85 },
      ],
      Stories: [
        { Id: 1, Name: '1 Story' },
        { Id: 7, Name: "Dual Owner's Retreat" },
      ],
    },
    objectID: '31_514',

    Elevations: [],
  },
  {
    BaseElevationPrice: 12345,
    Depth: 54,
    ExteriorStyle: {
      Id: 8,
      ExteriorStyleCategoryId: 1,
      Name: 'Traditional Farmhouse',
    },
    Id: 481,

    FloorPlans: [
      {
        BasePrice: 500,
        ElevationId: 2,
        HasModelHome: true,
        Id: 1,
        IsPopular: true,
        IsPreferred: true,
        PlanId: 200,
        PopularRank: 1,

        StudioId: 1,
        FloorPlanImages: [
          {
            FileName:
              'https://static.schumacherhomes.com/public/assets/homes/Charleston-Traditional-Farmhouse.jpg',
            Type: 'Main story',
            TypeId: 1,
          },
        ],
      },
    ],
    indexName: '',

    Image:
      'https://static.schumacherhomes.com/public/assets/homes/Charleston-Traditional-Farmhouse.jpg',
    IsBaseElevation: false,
    IsPopular: false,
    IsPreferred: false,
    Name: 'Charleston Traditional Farmhouse',
    PopularRank: 0,
    SquareFeet: 2400,
    Width: 80,
    HasFloorPlans: false,
    Plan: {
      Bathrooms: 2,
      Bedrooms: 4,
      Collection: null,
      FlexRoom: true,
      FlexRoomIsBedroom: true,
      HasGarage: true,
      Id: 31,
      IsMultiGen: true,
      Name: 'Olivia',
      SimilarPlans: [
        { SimilarPlanId: 17 },
        { SimilarPlanId: 53 },
        { SimilarPlanId: 85 },
      ],
      Stories: [
        { Id: 1, Name: '1 Story' },
        { Id: 7, Name: "Dual Owner's Retreat" },
      ],
    },
    objectID: '31_481',

    Elevations: [],
  },
];

export const mockFilterConfig: IFilterConfig<any>[] = [
  {
    key: 'Price',
    label: 'Price',
    type: 'select',
    options: [
      { label: 'Under $300k', value: 'Under $300k' },
      { label: '$300k–$500k', value: '$300k–$500k' },
      { label: 'Over $500k', value: 'Over $500k' },
    ],
    default: '',
    filterFn: (item, value) => {
      const price = (item.Price as number) ?? 0;
      if (value === 'Under $300k') return price < 300000;
      if (value === '$300k–$500k') return price >= 300000 && price <= 500000;
      if (value === 'Over $500k') return price > 500000;
      return true;
    },
  },
  {
    key: 'ExteriorStyle',
    label: 'Exterior Style',
    type: 'select',
    options: [
      { label: 'Modern', value: '5' },
      { label: 'Craftsman', value: '2' },
      { label: 'American Tradition', value: '4' },
      { label: 'Farmhouse', value: '1' },
      { label: 'French Country', value: '3' },
      { label: 'Coastal', value: '7' },
    ],
    default: '',
    filterFn: (item, value) =>
      !value || item.ExteriorStyle?.ExteriorStyleId === value,
  },
  {
    key: 'Bedrooms',
    label: 'Bedrooms',
    type: 'select',
    options: [
      { label: '2', value: '2' },
      { label: '3', value: '3' },
      { label: '4', value: '4' },
      { label: '5+', value: '5+' },
    ],
    default: '',
    filterFn: (item, value) => {
      const beds = item.Plan?.Bedrooms ?? 0;
      if (!value) return true;
      if (value === '5+') return beds >= 5;
      return beds === Number(value);
    },
  },
  {
    key: 'Stories',
    label: 'Stories',
    type: 'select',
    options: [
      { label: '1', value: '1' },
      { label: '2', value: '2' },
      { label: '3', value: '3' },
    ],
    default: '',
    filterFn: (item, value) => {
      const storyCount = item.Plan?.Stories?.length ?? 0;
      if (!value) return true;
      return storyCount === Number(value);
    },
  },
  {
    key: 'SquareFeet',
    label: 'Square Footage',
    type: 'select',
    options: [
      { label: 'Under 1000', value: 'Under 1000' },
      { label: '1000–2000', value: '1000–2000' },
      { label: 'Over 3000', value: 'Over 3000' },
    ],
    default: '',
    filterFn: (item, value) => {
      const sqft = item.SquareFeet ?? 0;
      if (value === 'Under 1000') return sqft < 1000;
      if (value === '1000–2000') return sqft >= 1000 && sqft <= 2000;
      if (value === '2000–3000') return sqft >= 2000 && sqft <= 3000;
      if (value === 'Over 4000') return sqft > 4000;
      return true;
    },
  },
  {
    key: 'IsMultiGen',
    label: 'Multigenerational Plan',
    type: 'checkbox',
    options: null,
    default: false,
    filterFn: (item, value) => !value || item.Plan.IsMultiGen === true,
  },
];

export const mockSortConfig: ISortOption[] = [
  {
    label: 'Most Popular',
    value: 'popular',
    sortFn: (a, b) => (b.IsPopular ? 1 : 0) - (a.IsPopular ? 1 : 0),
  },
  {
    label: 'Name (A–Z)',
    value: 'name-asc',
    sortFn: (a, b) => (a.Plan?.Name ?? '').localeCompare(b.Plan?.Name ?? ''),
  },
];

export const mockRenderCard = (item: any) => {
  return (
    <div data-testid="home-plan-card">
      <h2>{item.Plan.Name}</h2>
    </div>
  );
};

export const mockRenderControls = ({
  config,
  filterValues,
  setFilter,
  resetFilters,
  filteredResults,
  totalResults,
  sort,
  setSort,
  sortOptions,
}: {
  config: IFilterConfig<any>[];
  filterValues: any;
  setFilter: any;
  resetFilters: any;
  filteredResults: number;
  totalResults: number;
  sort: string;
  setSort: any;
  sortOptions: any[];
}) => {
  return (
    <div>
      <span>Filtered Results: {filteredResults}</span>
      <span>Total Results: {totalResults}</span>
      <div>
        {config.map((item) => {
          return (
            <AtDropdown
              label={item.label}
              options={item.options || []}
              onChange={(value) => setFilter(item.key, value)}
              key={item.key}
              value={filterValues[item.key] as string}
            />
          );
        })}
      </div>
      <div>
        <AtDropdown
          label="Sort By"
          options={sortOptions}
          value={sort}
          onChange={setSort}
        />
      </div>

      <div>
        <button onClick={resetFilters}>Reset Filters</button>
      </div>
    </div>
  );
};

export const orFilteredGridMockProps = {
  data: mockHousePlanData,
  config: mockFilterConfig,
  initialSort: 'popular',
  renderCard: mockRenderCard,
  renderControls: mockRenderControls,
  sortOptions: mockSortConfig,
  isLoading: false,
};
